const getCierreAnterior = async idCaja => {
  try {
    // Intentar obtener el cierre anterior guardado para esta caja específica
    const cierreAnteriorGuardado = localStorage.getItem(`cierreAnterior_${idCaja}`);

    if (cierreAnteriorGuardado) {
      // Si existe un cierre anterior guardado, devolverlo
      return JSON.parse(cierreAnteriorGuardado);
    } else {
      // Si no existe, devolver un valor por defecto
      return { fecha: "12/11/2024", hora: "13:46:17" };
    }
  } catch (error) {
    console.error("Error al obtener cierre anterior:", error);
    // En caso de error, devolver valor por defecto
    return { fecha: "12/11/2024", hora: "13:46:17" };
  }
};

const cierreAnterior = {
  getCierreAnterior,
};

export default cierreAnterior;
